import { ListClients } from '@/components/Aside/ListClients';
import { LogoutButton } from '@/components/Aside/LogoutButton';
import { ProfilePreview } from '@/components/Aside/ProfilePreview';
import useAppStore from '@/store/app';

export const Drawer = ({ children }: { children: any }) => {
  const { isOpenDrawer } = useAppStore();

  return (
    <div className="drawer drawer-end">
      <input
        id="my-drawer-4"
        type="checkbox"
        checked={isOpenDrawer}
        readOnly
        className="drawer-toggle"
      />
      <div className="drawer-content">{children}</div>
      <div className="drawer-side z-40 pt-16">
        <div className="menu min-h-full w-full bg-card px-5 text-base-content">
          <ProfilePreview />

          <ListClients />

          <LogoutButton />
        </div>
      </div>
    </div>
  );
};
